import { useState } from 'react'
import { generateError } from '../../helpers/errors'
import { mutations } from '../../resources'
import { DeleteMessagingConversation } from '../../resources/messages/types'
import { patchMessagingConversation } from '../../store/messaging/actions'
import { useDispatch } from '../redux'

export const useDeleteConversation = () => {
    const [inProgress, setInProgress] = useState(false)
    const dispatch = useDispatch()

    const deleteConversation = (payload: DeleteMessagingConversation): Promise<void> => {
        setInProgress(true)
        return mutations
            .deleteMessagingConversation(payload)
            .then((response) => {
                dispatch(patchMessagingConversation(response))
            })
            .catch((error) => {
                throw generateError(error)
            })
            .finally(() => {
                setInProgress(false)
            })
    }

    return {
        deleteConversation,
        inProgress,
    }
}
